import { LanguageVO, SentenceCollectionVO } from "../models_generated";
import { LocalStoragePersistedObservable } from "../utils/local_storage_persisted_observable";

interface InfoResponse {
  languages: LanguageVO[];
  sentenceCollections: SentenceCollectionVO[];
}

export const BASE_URL = "/languages";
const LANGUAGES_URL = `${BASE_URL}/info.json?v1`;

class SentencesStore {

	public languages = new LocalStoragePersistedObservable<LanguageVO[]>("languages", []);
	public sentenceCollections = new LocalStoragePersistedObservable<SentenceCollectionVO[]>("collections", []);
	public done = new LocalStoragePersistedObservable<boolean>("store_initialized", false);

	constructor() {
		this.init();
	}

	private async init() {
		setTimeout(async () => {
			try {
				// Load available collections from API
				const response = await fetch(LANGUAGES_URL);
				if (!response.ok) {
					throw new Error(`HTTP error! status: ${response.status}`);
				}
				const data: InfoResponse = await response.json();
				this.languages.set(data.languages)
				this.sentenceCollections.set(data.sentenceCollections)
				this.done.set(true);
			} catch (err) {
				console.error(err);
			}
		}, 10);
	}
}

export const SENTENCES_STORE = new SentencesStore();